/**
 * interact.js 1.10.26
 *
 * Copyright (c) 2012-present Taye Adeyemi <dev@taye.me>
 * Released under the MIT License.
 * https://raw.github.com/taye/interact.js/main/LICENSE
 */

import modifiers from './plugin.js';
import interact from "../interact/index.js";
import "../snappers/plugin.js";
import './all.js';
import './aspectRatio.js';
import "../utils/extend.js";
import "../utils/rect.js";
import './base.js';
import './Modification.js';
import "../utils/clone.js";
import './restrict/edges.js';
import './restrict/pointer.js';
import "../utils/is.js";
import './restrict/rect.js';
import './restrict/size.js';
import './snap/edges.js';
import './snap/size.js';
import './snap/pointer.js';
import "../utils/getOriginXY.js";
import "../utils/hypot.js";
import './noop.js';

/* eslint-disable no-console, eol-last, import/no-duplicates,  import/no-extraneous-dependencies, import/order */
interact.use(modifiers);
//# sourceMappingURL=index.js.map
